// extracted by mini-css-extract-plugin
export default {"button":"LightButton_button__GCS10","selected":"LightButton_selected__XIAxF"};